function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{opacity:0.8;}.cls-3{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M491.89,92.27q-.33.9-.7,1.78A39.56,39.56,0,0,1,472.58,114H379.43l20-21.06H485a33.13,33.13,0,0,0,6.89-.64m6.59-10.78a7.78,7.78,0,0,1-3,4.7Q492.24,88.6,485,88.6H397.54l-28.12,29.67H473.58a43.65,43.65,0,0,0,24.9-36.79Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M492.62,51.22c.4.53.77,1.09,1.14,1.64C493.39,52.3,493,51.76,492.62,51.22Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M500.75,69.76c0-.19-.08-.38-.12-.56.1.49.18,1,.26,1.47C500.84,70.37,500.8,70.06,500.75,69.76Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M501.18,72.55c-.08-.63-.19-1.25-.29-1.88C501,71.29,501.09,71.92,501.18,72.55Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M497.07,58.63a46.32,46.32,0,0,1,2,4.89,45.63,45.63,0,0,1,1.43,5.09c0,.19.08.38.12.58a44.44,44.44,0,0,0-6.87-16.34c.26.38.52.76.76,1.14A46.45,46.45,0,0,1,497.07,58.63Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M492.15,50.6l.47.62Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M406,74.21c.44-.34.83-.71,1.25-1.06a37.41,37.41,0,0,1-22.25-23.1,14.94,14.94,0,0,1-3.44,3.88q-5.39,4.35-14.79,4.35H266.47L256,117.81h35.85L297.1,88H358a95,95,0,0,0,27.32-3.66A62.91,62.91,0,0,0,406,74.21Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M171.89,119.72h0Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M171.89,119.72h0Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M172.48,119.72h0Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M172.48,119.72h0Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M159.19,116a28.71,28.71,0,0,1-7.75-9.31l-8.68-16.88h-.26l8.68,16.88a28.72,28.72,0,0,0,7.75,9.31q4.78,3.74,13,3.74h.17Q163.94,119.69,159.19,116Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M159.19,116a28.71,28.71,0,0,1-7.75-9.31l-8.68-16.88h-.26l8.68,16.88a28.72,28.72,0,0,0,7.75,9.31q4.78,3.74,13,3.74h.17Q163.94,119.69,159.19,116Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M172.06,119.71h0Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M151.18,106.67,142.5,89.79H41.24L56.56,1.38H20.71L0,119.72H171.89q-8.18,0-13-3.74A28.72,28.72,0,0,1,151.18,106.67Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M395,4.08a77.45,77.45,0,0,0-21.49-2.7H248.38L180.19,78.61l3.42,11.17,1.84,6a27.91,27.91,0,0,1,1,10.81c0,.33,0,.65-.08,1-.51,3.69-2.49,7.33-5.89,10.93a24.27,24.27,0,0,0,6.23-2.8,51.78,51.78,0,0,0,10.79-9l66.45-75H371.41q7.65,0,11.57,3c.23.18.44.37.65.56,1.55-12,9.29-22.14,20.12-27.79A52.29,52.29,0,0,0,395,4.08Z"
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M483.94,119.9l3.92-4.21a42.5,42.5,0,0,0,11.29-28.54,87.25,87.25,0,0,0-.64-9.27l0-.44-.19-.7a3.25,3.25,0,0,0-.57-1.13c-1.16-1.51-3.91-2.3-8-2.3h-63a83.24,83.24,0,0,1-10.39-.63c-1.45-.18-2.55-.35-3.55-.54-.77-.14-1.48-.31-2.18-.48l-.21,0a33.47,33.47,0,0,1-13.85-6.4c-6.58-5.46-9.92-12.81-9.92-21.84,0-.76,0-1.48.09-2.18l0-.6a43.75,43.75,0,0,1,3.15-14.35,35.69,35.69,0,0,1,10.54-13.95,41.38,41.38,0,0,1,5.68-3.89,57.46,57.46,0,0,1,12.6-5.22C426.06,1.07,435,0,445.24,0H550.46L518.1,34.32h-81c-5.46,0-8.09,1-9.34,1.8s-2.08,2.44-2.23,4.74c0,.16,0,.32,0,.47a3.13,3.13,0,0,0,0,.32A3.19,3.19,0,0,0,427,44.58c1.49,1,4,1.48,7.35,1.48l55.4,0,2.29,0c2.25,0,4.08,0,5.77,0,2.11,0,4,.11,5.81.23,2.07.14,4,.34,5.8.62A55.8,55.8,0,0,1,515.17,48a45.27,45.27,0,0,1,5.62,1.84,33.74,33.74,0,0,1,6.11,3.19h0A23.52,23.52,0,0,1,533.79,60c2.58,4.07,3.86,9.37,3.8,15.74-.1,10.78-3.69,20.65-10.09,27.8A43.45,43.45,0,0,1,509.89,115a82.39,82.39,0,0,1-20.22,4.31Zm19-26.23a47.18,47.18,0,0,1-8.43,20.68,69.32,69.32,0,0,0,13.86-3.39,39.76,39.76,0,0,0,15.9-10.33c5.71-6.37,8.9-15.23,9-25,.05-5.53-1-10-3.13-13.4a19.26,19.26,0,0,0-5.65-5.6,29.45,29.45,0,0,0-5.33-2.78,41,41,0,0,0-5.09-1.67,51.51,51.51,0,0,0-5.29-1.06c-1.72-.26-3.51-.45-5.46-.58-1.72-.12-3.55-.19-5.58-.22-1.32,0-2.74,0-4.4,0L494.71,52c.43.53,5.78,7.56,7.69,22h0c.14,1.08.27,2.19.39,3.38a90.68,90.68,0,0,1,.67,9.75,45.2,45.2,0,0,1-.3,5L503,93.67ZM445.24,4.31c-9.87,0-18.37,1-25.28,3a53.18,53.18,0,0,0-11.65,4.82,37.08,37.08,0,0,0-5.09,3.49,31.44,31.44,0,0,0-9.3,12.27,39.48,39.48,0,0,0-2.83,12.94l0,.62c0,.66-.08,1.29-.08,1.92,0,7.8,2.74,13.86,8.37,18.53a29.26,29.26,0,0,0,12.09,5.52l.21,0c.67.16,1.31.31,2,.43.92.17,1.94.32,3.3.5a79,79,0,0,0,9.85.59h63a20,20,0,0,1,7.74,1.27l-.09-.48h0v0l0-.11c-.25-1.22-.59-2.43-.85-3.34h0c-.13-.46-.28-.89-.41-1.32h0v0c-.26-.78-.55-1.58-.86-2.38v0h0c-.23-.62-.5-1.18-.73-1.72h0c-.36-.81-.7-1.51-1-2.14h0c-.17-.34-.33-.66-.49-.95h0c-.65-1.18-1.29-2.23-2-3.21l-.1-.14h0l-1.51-2.11h0c-.54-.7-1.05-1.32-1.56-1.9H434.37c-4.31,0-7.49-.72-9.72-2.19a7.48,7.48,0,0,1-3.47-6.52,6.66,6.66,0,0,1,.06-.82c0-.08,0-.16,0-.25.24-3.68,1.64-6.4,4.16-8.06S431.82,30,437.13,30h79.12L540.48,4.31Z"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M491.89,92.27q-.33.9-.7,1.78A39.56,39.56,0,0,1,472.58,114H379.43l20-21.06H485a33.13,33.13,0,0,0,6.89-.64m6.59-10.78a7.78,7.78,0,0,1-3,4.7Q492.24,88.6,485,88.6H397.54l-28.12,29.67H473.58a43.65,43.65,0,0,0,24.9-36.79Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 369.42,
  y: 81.49,
  width: 2.26,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 371.68,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 373.66,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 375.64,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 377.63,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 379.61,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 381.59,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 383.57,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 385.55,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 387.53,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 389.51,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 391.49,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 393.48,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 395.46,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 397.44,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 399.42,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.4,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 403.38,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 405.36,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 407.34,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 409.33,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 411.31,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 413.29,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 415.27,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 417.25,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 419.23,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 421.21,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 423.19,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 425.18,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 427.16,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 429.14,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 431.12,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 433.1,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 435.08,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 437.06,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 439.04,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 441.03,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 443.01,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 444.99,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 446.97,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 448.95,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 450.93,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 452.91,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.89,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 456.88,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 458.86,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 460.84,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 462.82,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 464.8,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 466.78,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 468.76,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 470.74,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 472.73,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 474.71,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 476.69,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 478.67,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 480.65,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 482.63,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 484.61,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 486.59,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 488.58,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 490.56,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 492.54,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 494.52,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 496.5,
  y: 81.49,
  width: 1.98,
  height: 36.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 379.43,
  y: 92.27,
  width: 0.18,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 379.61,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 381.59,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 383.57,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 385.55,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 387.53,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 389.51,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 391.49,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 393.48,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 395.46,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 397.44,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 399.42,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.4,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 403.38,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 405.36,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 407.34,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 409.33,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 411.31,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 413.29,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 415.27,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 417.25,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 419.23,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 421.21,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 423.19,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 425.18,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 427.16,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 429.14,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 431.12,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 433.1,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 435.08,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 437.06,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 439.04,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 441.03,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 443.01,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 444.99,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 446.97,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 448.95,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 450.93,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 452.91,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.89,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 456.88,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 458.86,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 460.84,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 462.82,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 464.8,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 466.78,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 468.76,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 470.74,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 472.73,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 474.71,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 476.69,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 478.67,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 480.65,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 482.63,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 484.61,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 486.59,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 488.58,
  y: 92.27,
  width: 1.98,
  height: 21.7
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 490.56,
  y: 92.27,
  width: 1.33,
  height: 21.7
})));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M187.77,98.91v0c-.89-6.51-5.7-16.08-7.32-19.16l-.45-.85-.09-.16L141.12,1.38h-44l42.13,82,12,23.33A28.71,28.71,0,0,0,159,116q4.78,3.74,13,3.74c1,0,1.94-.06,2.88-.14C187.29,119.58,189.72,106.75,187.77,98.91Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.2,157.07l-2.75,2.86H35.61l2-11.14H41l-1.47,8.27Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M64.15,155.07q-.9,5-7.82,5a10.5,10.5,0,0,1-5.24-1,3.27,3.27,0,0,1-1.66-3,5.88,5.88,0,0,1,.1-1l1.12-6.28h3.45L53,155.07a4.43,4.43,0,0,0,0,.62,1.38,1.38,0,0,0,.18.73,1.26,1.26,0,0,0,.63.48,4.59,4.59,0,0,0,1.2.27,17.7,17.7,0,0,0,1.9.08,10.38,10.38,0,0,0,1.69-.12,3.32,3.32,0,0,0,1.14-.38,1.9,1.9,0,0,0,.69-.68,3,3,0,0,0,.34-1l1.12-6.28h3.46Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M83,148.79,79,152l-1.14.89-.78.6-.54.4-.38.27.34.32L77,155l.65.72.74.82,3,3.35H76.47l-3.15-3.68-4.56,3.68H64.48l4.21-3.35,1.24-1,.82-.64.54-.4.39-.27-.28-.26-.39-.4-.6-.65-.91-1-2.83-3.2h4.76l2.93,3.46,4.2-3.46Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M97.88,155.07q-.9,5-7.82,5a10.5,10.5,0,0,1-5.24-1,3.27,3.27,0,0,1-1.66-3,5.88,5.88,0,0,1,.1-1l1.12-6.28h3.45l-1.13,6.28a4.43,4.43,0,0,0,0,.62,1.38,1.38,0,0,0,.18.73,1.26,1.26,0,0,0,.63.48,4.59,4.59,0,0,0,1.2.27,17.7,17.7,0,0,0,1.9.08,10.38,10.38,0,0,0,1.69-.12,3.32,3.32,0,0,0,1.14-.38,1.9,1.9,0,0,0,.69-.68,3,3,0,0,0,.34-1l1.12-6.28H99Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M114.78,159.93h-4.61l-2-2.95h-5.29l-.52,2.95H98.95l1-5.69h9.69a3.31,3.31,0,0,0,.82-.1,2.38,2.38,0,0,0,.68-.28,1.48,1.48,0,0,0,.47-.46,1.11,1.11,0,0,0,.17-.61.9.9,0,0,0-.45-.82,2.4,2.4,0,0,0-1.25-.27h-9.69l2.76-2.9h7.16a10.9,10.9,0,0,1,1.77.15,5.39,5.39,0,0,1,1.65.54,3.45,3.45,0,0,1,1.21,1,2.76,2.76,0,0,1,.47,1.65,4,4,0,0,1-.26,1.43,4.07,4.07,0,0,1-.73,1.23,4.37,4.37,0,0,1-1.14.93,4.63,4.63,0,0,1-1.46.53q.23.22.52.55t.76.92Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M132.41,148.79l-7.94,7.46-.63,3.68h-3.46l.65-3.7-5.48-7.44H120l2.13,3.1.27.39.36.51.33.5.22.35.61-.63q.37-.4,1.11-1.13l3.08-3.08Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M143.31,148.79l3.71,7.39,6.53-7.39h4.08l-8.92,10.07a5,5,0,0,1-1,.87,2.57,2.57,0,0,1-1.42.38,2,2,0,0,1-1.24-.36,2.75,2.75,0,0,1-.74-.89l-5.18-10.07Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M170.34,157.07l-2.73,2.86H156.88l2-11.14h12.89l-2.75,2.9H161.8l-.23,1.33h8.81l-2.4,2.53h-6.86l-.27,1.51Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M184.52,159.93h-3.43l.77-4.3h-6.64l-.75,4.3H171l2-11.14h3.45l-.72,3.95h6.64l.7-3.95h3.45Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M190.13,159.93h-3.45l2-11.14h3.43Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M206.95,157.07l-2.71,2.86h-5.59a7.17,7.17,0,0,1-2.37-.37,5.54,5.54,0,0,1-1.83-1,4.56,4.56,0,0,1-1.59-3.5,5.24,5.24,0,0,1,.62-2.51,6.24,6.24,0,0,1,1.67-2,7.86,7.86,0,0,1,2.46-1.28,9.73,9.73,0,0,1,3-.46h7.81l-2.73,2.9h-5.59a4.53,4.53,0,0,0-1.46.23,3.89,3.89,0,0,0-1.21.65,3.18,3.18,0,0,0-.82,1,2.55,2.55,0,0,0-.3,1.22,2.08,2.08,0,0,0,.79,1.67,2.77,2.77,0,0,0,.89.47,3.72,3.72,0,0,0,1.15.17Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M220.23,157.07l-2.75,2.86h-9.84l2-11.14h3.43l-1.47,8.27Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M234.32,157.07l-2.73,2.86H220.86l2-11.14h12.89l-2.75,2.9h-7.21l-.23,1.33h8.81l-2.4,2.53h-6.86l-.27,1.51Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M257.36,152.37a4.12,4.12,0,0,1-.44,1.9,4.4,4.4,0,0,1-1.25,1.49,6,6,0,0,1-2,1,9.08,9.08,0,0,1-2.61.35h-5.83l-.5,2.85h-3.43l1-5.69h9.59a2.19,2.19,0,0,0,1.42-.42,1.31,1.31,0,0,0,.52-1.07.93.93,0,0,0-.37-.77,1.78,1.78,0,0,0-1.11-.29h-9.59l2.8-2.9h7a7.41,7.41,0,0,1,2.06.26,4.39,4.39,0,0,1,1.5.73,3.17,3.17,0,0,1,.92,1.13A3.32,3.32,0,0,1,257.36,152.37Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M273.61,159.93H269L267,157h-5.29l-.52,2.95h-3.45l1-5.69h9.69a3.31,3.31,0,0,0,.82-.1,2.38,2.38,0,0,0,.68-.28,1.48,1.48,0,0,0,.47-.46,1.11,1.11,0,0,0,.17-.61.9.9,0,0,0-.45-.82,2.4,2.4,0,0,0-1.25-.27h-9.69l2.76-2.9h7.16a10.9,10.9,0,0,1,1.77.15,5.39,5.39,0,0,1,1.65.54,3.45,3.45,0,0,1,1.21,1,2.76,2.76,0,0,1,.47,1.65,4,4,0,0,1-.26,1.43,4.07,4.07,0,0,1-.73,1.23,4.37,4.37,0,0,1-1.14.93,4.63,4.63,0,0,1-1.46.53q.23.22.52.55t.76.92Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M284.23,148.61a10.34,10.34,0,0,1,5.44,1.14,3.92,3.92,0,0,1,1.81,3.57,5.92,5.92,0,0,1-2.3,5.11q-2.3,1.68-7,1.68a10.27,10.27,0,0,1-5.44-1.15,3.94,3.94,0,0,1-1.81-3.58,5.9,5.9,0,0,1,2.3-5.1Q279.55,148.61,284.23,148.61Zm-1.53,8.61a19.83,19.83,0,0,0,2.72-.15,3.76,3.76,0,0,0,1.61-.55,1.94,1.94,0,0,0,.77-1.09,6.45,6.45,0,0,0,.2-1.76,2.19,2.19,0,0,0-.24-1.09,1.63,1.63,0,0,0-.77-.67,4.28,4.28,0,0,0-1.34-.32,23.82,23.82,0,0,0-4.66.07,3.76,3.76,0,0,0-1.61.55,2,2,0,0,0-.77,1.09,6.47,6.47,0,0,0-.2,1.76,2.12,2.12,0,0,0,.25,1.1,1.7,1.7,0,0,0,.77.66,4.15,4.15,0,0,0,1.32.32A19.24,19.24,0,0,0,282.7,157.22Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M307.94,148.79l-2.76,2.9h-4l-1.47,8.24H296.3l1.45-8.24h-5.23l2.76-2.9Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M320.46,157.07l-2.73,2.86H307l2-11.14h12.89l-2.75,2.9h-7.21l-.23,1.33h8.81l-2.4,2.53h-6.86l-.27,1.51Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M335.79,157.07l-2.71,2.86h-5.59a7.17,7.17,0,0,1-2.37-.37,5.54,5.54,0,0,1-1.83-1,4.56,4.56,0,0,1-1.59-3.5,5.24,5.24,0,0,1,.62-2.51,6.24,6.24,0,0,1,1.67-2,7.86,7.86,0,0,1,2.46-1.28,9.73,9.73,0,0,1,3-.46h7.81l-2.73,2.9h-5.59a4.53,4.53,0,0,0-1.46.23,3.88,3.88,0,0,0-1.21.65,3.18,3.18,0,0,0-.82,1,2.54,2.54,0,0,0-.3,1.22,2.08,2.08,0,0,0,.79,1.67,2.76,2.76,0,0,0,.89.47,3.71,3.71,0,0,0,1.15.17Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M352.31,148.79l-2.76,2.9h-4l-1.46,8.24h-3.45l1.45-8.24h-5.23l2.76-2.9Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M354.87,159.93h-3.45l2-11.14h3.43Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M366.81,148.61a10.34,10.34,0,0,1,5.44,1.14,3.92,3.92,0,0,1,1.81,3.57,5.92,5.92,0,0,1-2.3,5.11q-2.3,1.68-7,1.68a10.28,10.28,0,0,1-5.44-1.15,3.94,3.94,0,0,1-1.81-3.58,5.9,5.9,0,0,1,2.3-5.1Q362.13,148.61,366.81,148.61Zm-1.53,8.61a19.81,19.81,0,0,0,2.72-.15,3.76,3.76,0,0,0,1.62-.55,1.94,1.94,0,0,0,.77-1.09,6.47,6.47,0,0,0,.2-1.76,2.19,2.19,0,0,0-.24-1.09,1.63,1.63,0,0,0-.77-.67,4.29,4.29,0,0,0-1.34-.32,23.82,23.82,0,0,0-4.66.07,3.76,3.76,0,0,0-1.61.55,2,2,0,0,0-.77,1.09,6.48,6.48,0,0,0-.2,1.76,2.12,2.12,0,0,0,.25,1.1,1.7,1.7,0,0,0,.77.66,4.15,4.15,0,0,0,1.32.32A19.24,19.24,0,0,0,365.27,157.22Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M386,160.12a1.83,1.83,0,0,1-.64-.11,1.78,1.78,0,0,1-.64-.49l-5.74-6.13-1.15,6.54h-3.13l1.62-9.24a3.16,3.16,0,0,1,.32-.95,2.1,2.1,0,0,1,.52-.65,2,2,0,0,1,.67-.37,2.46,2.46,0,0,1,.75-.12,1.94,1.94,0,0,1,.63.11,1.6,1.6,0,0,1,.65.49l5.74,6.13,1.17-6.54h3.13L388.2,158a3,3,0,0,1-.32.95,2.44,2.44,0,0,1-.52.66,1.88,1.88,0,0,1-.67.37A2.41,2.41,0,0,1,386,160.12Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M407.79,153.24a4.9,4.9,0,0,1,2.76.64,2.14,2.14,0,0,1,.94,1.89,4.52,4.52,0,0,1-.3,1.66,3.28,3.28,0,0,1-1,1.32,4.61,4.61,0,0,1-1.7.87,9,9,0,0,1-2.52.31H395.64l2.71-2.86h8.44a1.73,1.73,0,0,0,1-.23.83.83,0,0,0,.32-.72q0-.67-1-.67H401a4.32,4.32,0,0,1-2.78-.73,2.4,2.4,0,0,1-.88-1.95,4.07,4.07,0,0,1,.3-1.57,3.23,3.23,0,0,1,1-1.27,4.68,4.68,0,0,1,1.69-.84,9,9,0,0,1,2.5-.3h9.67l-2.73,2.9H402a1.9,1.9,0,0,0-1,.21.78.78,0,0,0-.32.71q0,.63,1.07.63Z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M425.78,157.07,423,159.93H412.32l2-11.14h12.89l-2.75,2.9h-7.21L417,153h8.81l-2.4,2.53h-6.86l-.27,1.51Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M442.24,159.93h-4.61l-2-2.95h-5.29l-.52,2.95h-3.45l1-5.69h9.69a3.31,3.31,0,0,0,.82-.1,2.38,2.38,0,0,0,.68-.28,1.47,1.47,0,0,0,.47-.46,1.1,1.1,0,0,0,.17-.61.9.9,0,0,0-.45-.82,2.4,2.4,0,0,0-1.25-.27h-9.69l2.76-2.9h7.16a10.92,10.92,0,0,1,1.77.15,5.38,5.38,0,0,1,1.65.54,3.44,3.44,0,0,1,1.21,1,2.75,2.75,0,0,1,.47,1.65,4,4,0,0,1-.26,1.43,4.08,4.08,0,0,1-.73,1.23,4.35,4.35,0,0,1-1.14.93,4.63,4.63,0,0,1-1.47.53q.23.22.52.55t.76.92Z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M447.57,148.79l3.71,7.39,6.53-7.39h4.08L453,158.87a5,5,0,0,1-1,.87,2.57,2.57,0,0,1-1.42.38,2,2,0,0,1-1.24-.36,2.75,2.75,0,0,1-.74-.89l-5.18-10.07Z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M464.63,159.93h-3.45l2-11.14h3.43Z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M481.45,157.07l-2.71,2.86h-5.59a7.17,7.17,0,0,1-2.37-.37,5.54,5.54,0,0,1-1.83-1,4.56,4.56,0,0,1-1.59-3.5,5.24,5.24,0,0,1,.62-2.51,6.24,6.24,0,0,1,1.67-2,7.86,7.86,0,0,1,2.46-1.28,9.73,9.73,0,0,1,3-.46h7.81l-2.73,2.9h-5.59a4.53,4.53,0,0,0-1.46.23,3.88,3.88,0,0,0-1.21.65,3.18,3.18,0,0,0-.82,1,2.54,2.54,0,0,0-.3,1.22,2.08,2.08,0,0,0,.79,1.67,2.76,2.76,0,0,0,.89.47,3.71,3.71,0,0,0,1.15.17Z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M495.6,157.07l-2.73,2.86H482.15l2-11.14H497l-2.75,2.9h-7.21l-.23,1.33h8.81l-2.4,2.53h-6.86l-.27,1.51Z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M507.77,153.24a4.9,4.9,0,0,1,2.76.64,2.14,2.14,0,0,1,.94,1.89,4.52,4.52,0,0,1-.3,1.66,3.28,3.28,0,0,1-1,1.32,4.61,4.61,0,0,1-1.7.87,9,9,0,0,1-2.52.31H495.62l2.71-2.86h8.44a1.73,1.73,0,0,0,1-.23.83.83,0,0,0,.32-.72q0-.67-1-.67H501a4.32,4.32,0,0,1-2.78-.73,2.4,2.4,0,0,1-.88-1.95,4.07,4.07,0,0,1,.3-1.57,3.23,3.23,0,0,1,1-1.27,4.68,4.68,0,0,1,1.69-.84,9,9,0,0,1,2.5-.3h9.67l-2.73,2.9H502a1.9,1.9,0,0,0-1,.21.78.78,0,0,0-.32.71q0,.63,1.07.63Z"
});

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550.46 160.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo(typo,white)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.c7b04adc.svg";
export { ForwardRef as ReactComponent };